import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { zersetzungsgradZeilen } from './zersetzungsgrad-stufen';

@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Torf-Zersetzungsgrad nach von Post (H1–H10)</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<table class="table table-sm table-bordered zersetzung-table">
				<thead>
					<tr>
						<th>Gruppe</th>
						<th>Stufe</th>
						<th>Bezeichnung</th>
						<th>Pflanzenstruktur</th>
						<th>Quetschen (Rückstand)</th>
						<th>Strukturierte Pflanzenreste</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of rows" [class.group-start]="row.gruppenStart">
						<td *ngIf="row.gruppenZeilen" [attr.rowspan]="row.gruppenZeilen" class="group-cell" [style.background]="row.farbe">
							<strong>{{ row.gruppe }}</strong><br/><span class="group-label">{{ row.gruppenName }}</span>
						</td>
						<td class="stufe-cell"><strong>{{ row.stufe }}</strong></td>
						<td>{{ row.bezeichnung }}</td>
						<td>{{ row.pflanzenstruktur }}</td>
						<td>{{ row.quetschen }}</td>
						<td>{{ row.pflanzenreste }}</td>
					</tr>
				</tbody>
			</table>
			<p class="text-muted small mt-2 mb-0">Quelle: SEA TeilA, Darst. A 2-3, S. 92</p>
		</div>
	`,
	styles: [`
		.zersetzung-table {
			font-size: 0.82rem;
			min-width: 700px;
		}
		.zersetzung-table th {
			text-align: center;
			vertical-align: middle;
			background: #f8f9fa;
			white-space: nowrap;
		}
		.zersetzung-table td {
			vertical-align: middle;
		}
		.stufe-cell {
			text-align: center;
			white-space: nowrap;
		}
		.group-cell {
			text-align: center;
			vertical-align: middle;
			writing-mode: vertical-lr;
			transform: rotate(180deg);
			white-space: nowrap;
			padding: 0.5rem 0.3rem;
		}
		.group-label {
			font-size: 0.75rem;
		}
		.group-start td {
			border-top: 2px solid #adb5bd;
		}
	`]
})
export class ZersetzungsgradInfoModalComponent {
	activeModal = inject(NgbActiveModal);

	/**
	 * Die Reihe steht in zersetzungsgrad-stufen.ts — dieselbe, aus der das
	 * Stufen-Feld in der Substratfolge Farbe und Namen nimmt (seit 15.09.2026).
	 */
	rows = zersetzungsgradZeilen();
}
